import { VehicleChecksAreas } from '../../workshop/models/vehiclecheckarea.model';
import { VehicleSeverity } from '../../workshop/models/vehicleseverity.model';
import { VehicleType } from '../../vehicle/models/vehicle-type.model';

export class WalkaroundQuestion {
  id: number = -1;

  checkInformation: string = '';

  severity: number = -1;
  severityDetail: VehicleSeverity = new VehicleSeverity();

  isVor: boolean = false;

  vehicleTypeId: number = -1;
  vehicleType: VehicleType = new VehicleType();

  vehicleCheckAreaId: number = -1;
  vehicleCheckArea: VehicleChecksAreas = new VehicleChecksAreas();

  active: boolean = true;

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
